module.exports = "/images/laura.webp?0097d14437600f155bbf09fe26a759b7";